import React, { useState, useEffect } from "react";

import styled from "styled-components";
import { SourceProps, SourceType } from "Data/detail";
import useWindowSize from "Hooks/useWindowSize";
import { BREAKPOINT_MOBILE, BREAKPOINT_TABLET } from "Styles/media";
import SourceImage from "Components/SourceImage";
import { getYoutubeThumbnail } from "../../util";
import GalleryViewer from "./GalleryViewer";
import { useHeaderState } from "Provider/AppProvider";
import { useAboutScroll } from "Provider/AboutProvider";

const Wrapper = styled.div`
	position: relative;
	margin-top: 80px;
`;

const GalleryWrapper = styled.ul`
	display: flex;
	flex-wrap: wrap;
`;

const List = styled.li<{ col: number; isMargin: boolean }>`
	position: relative;
	${(props) => props.theme.layout.ratio(56.24)};
	cursor: pointer;
	border: 1px solid ${(props) => props.theme.color.bg};
	transition: ${(props) => props.theme.transition.default};
	width: ${(props) => `calc((100% - ${props.theme.size.gallery.gap * (props.col - 1)}px) / ${props.col})`};
	margin-right: ${(props) => `${props.isMargin ? props.theme.size.gallery.gap : 0}px`};
	margin-bottom: ${(props) => `${props.theme.size.gallery.gap}px`};

	&:hover {
		transform: scale(0.95);
	}
`;

const Image = styled(SourceImage)`
	position: absolute;
	left: 0;
	top: 0;
	width: 100%;
	height: 100%;
`;

const AboutGallery: React.FC<{ data: SourceProps[] }> = ({ data }) => {
	const [col, setCol] = useState(3);
	const { size } = useWindowSize();
	const [nowData, setNowData] = useState<SourceProps | undefined>();
	const { setHeaderState } = useHeaderState();
	const { setScrollDisable } = useAboutScroll();

	useEffect(() => {
		// note : hide header when gallery view active
		setHeaderState((n) => ({ ...n, hide: !!nowData }));
	}, [nowData, setHeaderState]);

	useEffect(() => {
		// note : disable scroll when gallery view active
		if (!!nowData) {
			setScrollDisable(true);
		} else {
			setScrollDisable(false);
		}
	}, [nowData, setScrollDisable]);

	useEffect(() => {
		if (size.width <= BREAKPOINT_MOBILE) {
			setCol(2);
		} else if (size.width <= BREAKPOINT_TABLET) {
			setCol(3);
		} else {
			setCol(3);
		}
	}, [size]);

	const handleListClick = (id: string) => {
		data.some((el) => el.id === id && setNowData(el));
	};
	const handleCloseClick = () => {
		setNowData(undefined);
	};

	return (
		<Wrapper>
			<GalleryViewer nowData={nowData} data={data} handleCloseClick={handleCloseClick} handleListClick={handleListClick} />
			<GalleryWrapper>
				{data.map((el, index) => {
					return (
						<List key={el.id} onClick={() => handleListClick(el.id)} col={col} isMargin={(index + 1) % col !== 0}>
							<Image image={el.type === SourceType.IMAGE ? el.value : getYoutubeThumbnail(el.value)} />
						</List>
					);
				})}
			</GalleryWrapper>
		</Wrapper>
	);
};

export default AboutGallery;
